import React from 'react';
import Select from 'react-select';
import PdfPSProbabilidadeInternacao from '../../PdfPSProbabilidadeInternacao';

/**
 * Paginação, impressão, busca e troca de tema.
 *
 * Recebe o próprio painel em vez de uma prop por controle: todos os botões apenas
 * chamam métodos que já vivem lá (changeCycle, actionPause, changeTheme).
 */
const BarraFerramentas = ({ painel, titulo }) => {
  const {
    theme,
    iconText,
    boolPause,
    cycle,
    totalCycles,
    numberOfElements,
    serachPacientes,
    filteredPacientes,
  } = painel.state;

  const listaImpressao = filteredPacientes.length === 0 ? serachPacientes : filteredPacientes;

  const filtrarPaciente = (opcao) => {
    const paciente = opcao
      ? serachPacientes.find(item => (item.nomepaciente === opcao.nome || item.codigoatendimento === opcao.codAtendimento))
      : null;
    painel.setState({ filteredPacientes: paciente ? [paciente] : serachPacientes });
  };

  return (
    <div className={"inforow " + theme}>
      <div className={'inforow right ' + theme}>
        <button className={'buttonIcon ' + theme} onClick={() => painel.changeCycle(0)}><img src={"/img/icon_arrow_left" + iconText + ".svg"} alt="" /></button>
        <button className={'buttonIcon ' + theme} onClick={() => painel.changeCycle(1)}><img src={"/img/icon_arrow_right" + iconText + ".svg"} alt="" /></button>
        <button className={'buttonIcon ' + theme} onClick={() => painel.actionPause(boolPause)}><img src={(boolPause === 1 ? "/img/icon_play" : "/img/icon_pause") + iconText + ".svg"} alt="" /></button>
        <div className='infoText'>{painel.textoGrupoPacientes(cycle, totalCycles, numberOfElements)}</div>
      </div>
      <div className={'inforow left ' + theme}>
        <div className="paginacao">
          <div className="infoText">Página {cycle} de {totalCycles}</div>
        </div>
        <PdfPSProbabilidadeInternacao title={titulo} list={listaImpressao} theme={theme} />
        <form>
          <div className={'buttonSearch ' + theme}>
            <img src={"/img/icon_search" + iconText + ".svg"} alt="" />
            <Select className={'selectSearch ' + theme}
              placeholder="Busque por um paciente ou atendimento..."
              options={
                serachPacientes.map(opt => ({
                  key: opt.codigoatendimento,
                  label: opt.nomepaciente + " \n(" + opt.codigoatendimento + ")",
                  value: opt.codigoatendimento,
                  nome: opt.nomepaciente,
                  codAtendimento: opt.codigoatendimento,
                }))}
              onFocus={() => painel.actionPause(0)}
              onBlur={() => painel.actionPause(1)}
              isClearable={true}
              onChange={filtrarPaciente}
            />
          </div>
        </form>
        <button className={'buttonIcon ' + theme} onClick={() => painel.changeTheme()}><img src={"/img/icon_theme" + iconText + ".svg"} alt="" /></button>
      </div>
    </div>
  );
};

export default BarraFerramentas;
